import { getAccessToken } from "@privy-io/react-auth"
import axios from "axios"

const httpClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
})

httpClient.interceptors.request.use(async (config) => {
  if (!config.headers.Authorization) {
    const accessToken = await getAccessToken()
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
  }

  return config
})

export { httpClient }
